import { render } from "./PalmAndTreesByArea.vue?vue&type=template&id=9e19ee96"
import script from "./PalmAndTreesByArea.vue?vue&type=script&lang=js"
export * from "./PalmAndTreesByArea.vue?vue&type=script&lang=js"
script.render = render

export default script